import styled, { css } from 'styled-components';

import mixin from '../../_foundations/Mixin';

const clusterSize = (count) => {
  let size = 50;
  if (count > 10000) {
    size = 100;
  } else if (count > 1000) {
    size = 80;
  } else if (count > 100) {
    size = 60;
  }
  return size;
};

export const MapClusterContainer = styled.div`
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: bold;
  font-family: 'Poppins', sans-serif;
  color: var(--neutral-1000);
  ${mixin.elevation()}
  ${(props) => css`
    height: ${clusterSize(props.count)}px;
    width: ${clusterSize(props.count)}px;
    border: solid 3px ${props.color};
    transform: translate(-50%, -50%);
  `};

  border-radius: 50%;
`;

export default MapClusterContainer;
